import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import Flexbox from 'flexbox-react';
import ProcessUtils from 'utils/ProcessUtils';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import ComponentUtils from 'utils/ComponentUtils';
import RIEToggle from 'components/core/editable/RIEToggle';
import InfoIcon from 'components/core/InfoIcon';
import InfoMessages from 'components/core/help/InfoMessages';

const verticalStyles = css`
    align-self: flex-start !important;
    .form-label {
        font-weight: normal !important
    }
`;

export default class VariableRequiredOptionsForm extends React.Component {
    static propTypes = {
        process: PropTypes.object,
        variableRequired: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired, //empty string for no selection, null is considered uncontrolled and throws warning
        retrieveQCVariable: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired,
        qcVariableRequired: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired,
        onVariableRequiredChanged: PropTypes.func, // default is to update based on field path, but custom function can be passed in when not directly editing the process
        onRetrieveQCVariableChanged: PropTypes.func,
        onQCVariableRequiredChanged: PropTypes.func,
        variableRequiredText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        retrieveQCVariableText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        qcVariableRequiredText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        retrievedVariableName: PropTypes.string, // required if using default update field function rather than passing in specific function
        isDisabled: PropTypes.bool,
        className: PropTypes.string,
        inlineStyle: PropTypes.bool,
        labelWrap: PropTypes.bool
    };

    static defaultProps = {
        variableRequiredText: 'Is successful retrieval of the variable required for the process to successfully run?',
        retrieveQCVariableText: 'Should the companion qc variable be retrieved?',
        qcVariableRequiredText: 'Is successful retrieval of the companion qc variable required for the process to successfully run?',
        inlineStyle: false,
        isDisabled: false,
        labelWrap: false
    };

    getFormattedValue = (value) => {
        return value ? 1 : 0;
    };

    getBaseFieldPath = () => {
        let basePath = [];
        if (this.props.retrievedVariableName) {
            basePath = ['variable_retrieval', 'retrieved_variables', this.props.retrievedVariableName];
        }

        return basePath;
    };

    onVariableRequiredChanged = (fieldPath, value) => {
        const newValue = this.getFormattedValue(value);

        if (this.props.onVariableRequiredChanged) {
            this.props.onVariableRequiredChanged(newValue)
        } else {
            ProcessUtils.updateField(this.props.process, fieldPath, newValue);
        }
    };

    onRetrieveQCVariableChanged = (fieldPath, value) => {
        const newValue = this.getFormattedValue(value);

        if (this.props.onRetrieveQCVariableChanged) {
            this.props.onRetrieveQCVariableChanged(newValue)
        } else {
            ProcessUtils.updateField(this.props.process, fieldPath, newValue);
        }
    };

    onQCVariableRequiredChanged = (fieldPath, value) => {
        const newValue = this.getFormattedValue(value);

        if (this.props.onQCVariableRequiredChanged) {
            this.props.onQCVariableRequiredChanged(newValue)
        } else {
            ProcessUtils.updateField(this.props.process, fieldPath, newValue);
        }
    };

    getValue = (value) => {
        let formattedValue = value;
        if (value !== '' && typeof value !== "boolean") {
            formattedValue = value === 1;
        }

        return formattedValue;
    };

    render = () => {
        const labelClassName = this.props.inlineStyle ? '': `${verticalStyles}`;
        const flexDirection = this.props.inlineStyle ? 'row' : 'column';
        const fieldMarginBottom = this.props.inlineStyle ? 5 : 10;
        const fieldStyles = css`
            margin-bottom: ${fieldMarginBottom}px;
        `;
        let displayQCRequired = true;
        if (this.props.retrieveQCVariable !== '' && !this.props.retrieveQCVariable) {
            displayQCRequired = false;
        }

        return (
            <Flexbox className={this.props.className} flexDirection={'column'}>
                <Flexbox flexDirection={flexDirection} className={fieldStyles}>
                    <InfoBoxLabel
                        className={labelClassName}
                        label={this.props.variableRequiredText}
                        hideColon
                        labelWrap={this.props.labelWrap}
                        message={InfoMessages.retrievedVariableRequired}
                    />
                    <RIEToggle
                        value={this.getValue(this.props.variableRequired)}
                        textTrue="Yes"
                        textFalse="No"
                        fieldPath={[...this.getBaseFieldPath(), 'variable_required']}
                        change={this.onVariableRequiredChanged}
                        isDisabled={this.props.isDisabled}
                        radioGroupName="variable_required"
                        processId={this.props.process.name}
                    />
                </Flexbox>
                <Flexbox flexDirection={flexDirection} className={fieldStyles}>
                    <InfoBoxLabel
                        className={labelClassName}
                        label={this.props.retrieveQCVariableText}
                        hideColon
                        message={InfoMessages.retrievedVariableRequired}
                    />
                    <RIEToggle
                        value={this.getValue(this.props.retrieveQCVariable)}
                        textTrue="Yes"
                        textFalse="No"
                        fieldPath={[...this.getBaseFieldPath(), 'retrieve_qc_variable']}
                        change={this.onRetrieveQCVariableChanged}
                        isDisabled={this.props.isDisabled}
                        radioGroupName="retrieve_qc_variable"
                        processId={this.props.process.name}
                    />
                </Flexbox>
                {displayQCRequired &&
                <Flexbox flexDirection={flexDirection} className={fieldStyles}>
                    <InfoBoxLabel
                        className={labelClassName}
                        label={this.props.qcVariableRequiredText}
                        hideColon
                        message={InfoMessages.retrievedVariableQCRequired}
                    />
                    <RIEToggle
                        value={this.getValue(this.props.qcVariableRequired)}
                        textTrue="Yes"
                        textFalse="No"
                        fieldPath={[...this.getBaseFieldPath(), 'qc_variable_required']}
                        change={this.onQCVariableRequiredChanged}
                        isDisabled={this.props.isDisabled}
                        radioGroupName="qc_variable_required"
                        processId={this.props.process.name}
                    />
                </Flexbox>
                }
            </Flexbox>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/forms/VariableRequiredOptionsForm.js